import type { LocalePack } from './types.js';

/** Turkish (Türkçe) */
export const tr: LocalePack = {
  headerTitle: 'Fotoğraf Düzenleyici',
  headerSubtitle: 'Görüntünüzü kolayca düzenleyin',
  applyButton: 'Uygula',
  cancelButton: 'Kapat',
  undo: 'Geri al',
  redo: 'Yinele',
  fullscreen: 'Tam ekran',
  fit: 'Sığdır',
  zoomTooltip: 'Yakınlaştır · +/− · 0 sığdır · 1 %100',

  emptyStateTitle: 'Bir görüntü bırakın veya yüklemek için tıklayın',
  emptyStateSubtitle: 'Desteklenen: PNG, JPEG, HEIC',

  calloutLabelText: 'Etiket',

  tool: {
    select: 'Seç',
    crop: 'Kırp',
    draw: 'Çiz',
    eraser: 'Silgi',
    text: 'Metin',
    shapes: 'Şekiller',
    callout: 'Not',
    filters: 'Filtreler',
    adjust: 'Ayarla',
    move: 'Taşı',
    pen: 'Kalem',
    zoom: 'Yakınlaştırma',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    rotateLeft: 'Sola döndür',
    rotateRight: 'Sağa döndür',
    flipH: 'Yatay çevir',
    flipV: 'Dikey çevir',
    reset: 'Sıfırla',
  },

  shape: {
    circle: 'Daire',
    ellipse: 'Elips',
    square: 'Kare',
    rectangle: 'Dikdörtgen',
    arrow: 'Ok',
    polyline: 'Çizgi',
  },

  filter: {
    none: 'Orijinal',
    grayscale: 'S/B',
    sepia: 'Sepya',
    vintage: 'Vintage',
    cool: 'Soğuk',
    warm: 'Sıcak',
    invert: 'Ters çevir',
  },

  props: {
    title: {
      draw: 'Çiz',
      eraser: 'Silgi',
      text: 'Metin',
      crop: 'Kırp',
      shapes: 'Şekiller',
      callout: 'Not',
      filters: 'Filtreler',
      adjust: 'Ayarla',
      move: 'Taşı',
    },
    aspectRatio: 'En-boy oranı',
    applyCrop: 'Kırpmayı uygula',
    cancel: 'İptal',
    shape: 'Şekil',
    preset: 'Hazır ayar',
    resetEffects: 'Efektleri sıfırla',
    resetAdjustments: 'Ayarları sıfırla',
    deleteSelected: 'Seçileni sil',
    colors: 'Renkler',
    recent: 'Son kullanılan',
    customColor: 'Özel renk',
    brushSize: 'Fırça boyutu',
    strokeWidth: 'Çizgi kalınlığı',
    opacity: 'Opaklık',
    eraserSize: 'Silgi boyutu',
    fontSize: 'Yazı tipi boyutu',
    brightness: 'Parlaklık',
    contrast: 'Kontrast',
    saturation: 'Doygunluk',
    blur: 'Bulanıklık',
    quickActions: 'Hızlı işlemler',
    hintMove:
      'Kaydırmak için sürükleyin · yakınlaştırmak için sıkın veya kaydırın · başlamak için bir araç seçin.',
    hintEraser: 'Kaldırmak için bir açıklamaya dokunun veya sürükleyin.',
  },
};
